import { createFileRoute } from '@tanstack/react-router'
import { PackConfigPage } from '../../../../modules/settings/pack-config-page'
import { SettingsShell } from '../../../../modules/settings/settings-shell'

/** The active workspace's vertical-pack config editor. */
export const Route = createFileRoute('/_authed/settings/packs/')({
  component: () => (
    <SettingsShell>
      <PackConfigPage />
    </SettingsShell>
  ),
})
